import "./Footer.css";

export const Footer = () => {
  return (
    <div className="Footer">
      <div className="Footer_Body">
        <div className="Footer_Content Left"> Made with 💛 By Notero Team. </div>
        <div className="Footer_Separator">
          <img height="45" src="./Footer_Decorate_Flower.png" alt="flower" />{" "}
        </div>
        <div className="Footer_Content Right"> support@notero.co </div>
      </div>
    </div>
  );
};
